import React from 'react';
import Navbar from './Navbar';

const Header: React.FC = () => {
	return (
	<header>
    	<div className="red_line"></div>
		<Navbar />
	</header>
	);
};

export default Header;
